import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import Getuser from "../../Services/Getuser";

const AssignVehicleToDriver = ({ vehicle, setVehicles, setShowModal }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [drivers, setDrivers] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const inputRef = useRef(null);

  // Fetch suggestions as the user types
  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!searchTerm.trim()) {
        setSuggestions([]);
        setShowSuggestions(false);
        return;
      }

      try {
        // const response = await axios.get(
        //   `https://binberu.idaprocharity.com/api/v1/admin/search-drivers-no-vehicles?name=${encodeURIComponent(
        //     searchTerm,
        //   )}`,
        // );

        const response = await Getuser.SearchDrivers(
          encodeURIComponent(searchTerm),
        );
        setSuggestions(response.data || []);
        setShowSuggestions(true);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    };

    const debounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(debounce);
  }, [searchTerm]);

  // Handle suggestion click
  const handleSuggestionClick = (driver) => {
    setSearchTerm(driver.name);
    setDrivers([driver]); // Set only the selected driver's details
    setShowSuggestions(false);
  };

  // Handle click outside to close suggestions
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Function to assign vehicle to driver
  const assignVehicle = async (driverId) => {
    try {
      const response = await Getuser.AddVehicleToDriver({
        id: vehicle.id,
        model: vehicle.model,
        plate_no: vehicle.plate_no,
        year: vehicle.year,
        km_per_litter: vehicle.km_per_litter,
        color: vehicle.color,
        service_type: vehicle.service_type,
        owner_name: vehicle.owner_name,
        photo_url: vehicle.photo_url,
        driver_id: driverId,
      });

      // 👇 This is the updated vehicle from the backend
      const updatedVehicle = response.data;

      // console.log("VeHI", updatedVehicle);
      // ✅ Update table using response data
      setVehicles((prevVehicles) =>
        prevVehicles.map((v) =>
          v.id === updatedVehicle.id ? updatedVehicle : v,
        ),
      );

      toast.success("Vehicle assigned successfully!");
      setShowModal(false);
    } catch (error) {
      console.error("Error assigning vehicle:", error);
      toast.error("Failed to assign vehicle. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <div
        style={{
          maxHeight: "80vh",
          overflowY: "auto",
          border: "1px solid #ccc",
          padding: "15px",
          borderRadius: "5px",
        }}
      >
        <div
          className="form-group"
          style={{ position: "relative" }}
          ref={inputRef}
        >
          <label htmlFor="driver_name" className="col-form-label">
            Search Driver by Name
          </label>
          <input
            id="driver_name"
            name="driver_name"
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control"
            placeholder="Enter driver name"
            autoComplete="off"
          />

          {showSuggestions && suggestions.length > 0 && (
            <ul
              className="list-group"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                zIndex: 1000,
                maxHeight: "200px",
                overflowY: "auto",
                marginTop: "5px",
              }}
            >
              {suggestions.map((driver) => (
                <li
                  key={driver.id}
                  className="list-group-item"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSuggestionClick(driver)}
                >
                  {driver.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        {!loading && drivers.length > 0 && (
          <div className="mt-4">
            <h4 className="text-lg font-bold mb-3">Driver Details</h4>
            {drivers.map((driver) => (
              <div key={driver.id} className="border p-3 rounded mb-2 bg-light">
                <p>
                  <strong>Name:</strong> {driver.name}
                </p>
                <p>
                  <strong>Email:</strong> {driver.email}
                </p>
                <p>
                  <strong>Phone:</strong> {driver.phone_number}
                </p>
                <p>
                  <strong>Registration Number:</strong>{" "}
                  {driver.registration_number}
                </p>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Plate No</th>
                      <th>Year</th>
                      <th>Owner</th>
                    </tr>
                  </thead>
                  <tbody>
                    {driver.vehicles.map((v) => (
                      <tr key={v.id}>
                        <td>{v.plate_no}</td>
                        <td>{v.year}</td>
                        <td>{v.owner_name}</td>
                        <td>
                          <span
                            className="insurance-status"
                            style={{
                              color: v.insurance_status ? "green" : "red",
                              backgroundColor: v.insurance_status
                                ? "#d4edda"
                                : "#f8d7da",
                              cursor: "pointer",
                            }}
                          >
                            {v.insurance_status ? "Active" : "Expired"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <button
                  className="btn btn-primary mt-3"
                  onClick={() => assignVehicle(driver.id)}
                >
                  Assign
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="d-flex justify-content-end mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowModal(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignVehicleToDriver;
